import {Directive, ElementRef, Input, OnInit} from '@angular/core';
import {TokenService} from '../../services/token.service';

@Directive({
  selector: `[isSignedIn]`
})
export class IsSignedInDirective implements OnInit {
  @Input('isSignedIn') isSignedIn = true;

  constructor(private el: ElementRef, private authToken: TokenService) {
  }

  ngOnInit(): void {
    this.authToken.isLoggedIn.subscribe(x => {
      this.el.nativeElement.style.display = x === this.isSignedIn ? '' : 'none';
    });
  }
}
